import React from 'react'

const SvgSkinFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.987 11.215a2.329 2.329 0 012.566-.32.995.995 0 00.447.104v9a2 2 0 01-2 2H4a2 2 0 01-2-2v-9c.15 0 .303-.033.447-.105a2.329 2.329 0 012.566.32l.271.238a3.923 3.923 0 005.357-.179c.75-.75 1.968-.75 2.718 0a3.923 3.923 0 005.357.179l.271-.237zM8 18a1 1 0 100 2 1 1 0 000-2zm8 0a1 1 0 100 2 1 1 0 000-2zM5 14a1 1 0 100 2 1 1 0 000-2zm7 0a1 1 0 100 2 1 1 0 000-2zm7 0a1 1 0 100 2 1 1 0 000-2z'
    />
    <path d='M20 6a2 2 0 012 2v.915a4.325 4.325 0 00-4.33.795l-.27.237a1.923 1.923 0 01-2.627-.088 3.922 3.922 0 00-5.546 0 1.923 1.923 0 01-2.626.088l-.27-.237A4.325 4.325 0 002 8.915V8c0-.753.385-1.66 1-2-.02-.08 0 .086 0 0 0-1.52.82-2.921 2.144-3.666l.366-.205a1 1 0 11.98 1.742l-.366.206A2.206 2.206 0 005 6h6c0-1.52.82-2.921 2.144-3.666l.366-.205a1 1 0 11.98 1.742l-.366.206A2.206 2.206 0 0013 6h5c0-1.52.82-2.921 2.144-3.666l.366-.205a1 1 0 11.98 1.742l-.366.206A2.206 2.206 0 0020 6z' />
  </svg>
)

export default SvgSkinFilled
